<div class="ct-menu-item">
    <ng-content></ng-content>
</div>